import React from "react";

const AromaSpaWellness = () => {
  return (
    <div className="headSpaHeadContainer">
      <h2>A Holistic Approach to Wellness</h2>
      <p>
        At SCENT, <a href="https://scentlifestyle.com/facial">aroma massage</a> is part of a holistic approach to
        wellness. The salon offers a wide range of treatments, including body
        massages, <a href="https://scentlifestyle.com/facial">facials</a>, and <a href="https://scentlifestyle.com/hair-salon">haircuts</a>, all
        designed to promote overall well-being. This integrated approach allows
        clients to enjoy a comprehensive wellness experience that addresses both
        physical and mental health.
      </p>
    </div>
  );
};

export default AromaSpaWellness;
